// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button img[data-v-72ae52f5]{filter:invert(100%)}.text-container[data-v-72ae52f5]{text-wrap:nowrap}", ""]);
// Exports
module.exports = exports;
